import moment from "moment";
import PopUp from "@/components/popUp/PopUp.vue";
import { localize } from "vee-validate";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {

	props: ["properties"],
	components: {PopUp, },

	data() {
		return {
			navItems: [
				{
					itemName: "sidebar.overview",
					nonTrasnalteName: "Overview",
					link: "/",
					testId: "sidebar-overview",
					position: "top"
				},
				{
					itemName: "sidebar.categories",
					nonTrasnalteName: "Categories",
					link: "/category-breakdown",
					testId: "sidebar-category-breakdown",
					position: "top"
				},
				{
					itemName: "sidebar.my_goals",
					nonTrasnalteName: "My goals",
					link: "/my-goals",
					testId: "sidebar-my-goals",
					position: "top"
				},
				{
					itemName: "sidebar.tracked_items",
					nonTrasnalteName: "Tracked items",
					link: "/tracked-items",
					testId: "sidebar-tracked-items",
					position: "top"
				},
				{
					itemName: "sidebar.settings",
					nonTrasnalteName: "Settings",
					link: "/settings",
					testId: "sidebar-settings",
					position: "top"
				},
				{
					itemName: "sidebar.help",
					nonTrasnalteName: "Help",
					link: "/help",
					testId: "sidebar-help",
					position: "top"
				}
			],
			languages: [ "en", "de", "fr" ],
			activeLanguage: localStorage.getItem("language") || "en",
			showPropertyDropdown: true,
			showPopup: false,
		};
	},

	methods: {
		goTo,
		changeLanguage,
		togglePopup
	},

	computed: {
		...brandingGetters([
			"logoHome"
		])
	},
};

function goTo(item) {
	this.$ma.trackView({viewName: item.nonTrasnalteName});

	if (item.openInNewTab) {
		window.open(item.link);
		return;
	}

	this.$router.push({
		path: item.link,
		query: {from: "side_menu"}
	});
}

function changeLanguage(language) {
	language = language || "en";
	this.activeLanguage = language;
	this.$i18n.locale = language;
	moment.locale(language);
	localize(language);

	this.$ma.trackEvent({
		action: "Side Nav Language changed",
		properties: {
			"Value": language,
			"Component": this.$route.name
		}
	});

	localStorage.setItem("language", language);
	this.$eventBus.$emit("updateLanguage");
	this.$utils.initMixpanelBeforeTrack(this);
	location.reload();
}

function togglePopup() {
	this.showPopup = !this.showPopup;
}
